import { createReducer } from '@reduxjs/toolkit'
import { DesignerT } from 'shared/types/model'
import { receiveUser, clear, logout } from 'model/actions'

const initialState = null as DesignerT | null

const reducer = createReducer(initialState, builder => {
  builder
    .addCase(receiveUser, (state, action) => action.payload)
    .addCase(clear, () => initialState)
    .addCase(logout, () => initialState)
})

export default reducer
